import  charts from './module/charts';
const api = {}
Object.keys(charts).forEach(key => {
    api[key] = charts[key]
  })
export default api